<template>
  <div
    class="composer-modal"
  >
    <header class="composer-modal__header">
      <h3 class="composer-modal__title" v-html="title"></h3>

      <button
        @click="close()"
        class="composer-modal__close"
      >
        <i class="icon icon-times"></i>
      </button>
    </header>

    <content class="composer-modal__content-wrapper">
      <div class="composer-modal__content">
        <slot name="content"></slot>
      </div>
    </content>

    <footer class="composer-modal__footer">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    close (params) {
      params = params || null;

      this.$root.$emit('composerModal:close', params);
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Modal
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Modal for the Composer
 * @since 2022-07-29
**/

$component: 'composer-modal';

.#{$component} {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 8;
  border-radius: $border-radius-lg;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include padding(map-get($spacers, 2) map-get($spacers, 4));
    border-top-left-radius: $border-radius-lg;
    border-top-right-radius: $border-radius-lg;
    border-top: 1px solid $sky;
    background-color: $sky-lighter;
  }

  &__title {
    margin: 0;
    @include font-size($font-size-lg);
    line-height: $line-height-base-lg;
  }

  &__close {
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    background: transparent;
    color: $ink-lighter;
    @include font-size($font-size-base * 1.8);
    line-height: 0;
  }

  &__content {
    // position: relative;
    // flex-grow: 1;
    // width: 100%;
    // overflow-x: hidden;
    // overflow-y: scroll;
    // @include padding(map-get($spacers, 4));
    // background-color: $white;
    // box-shadow:
    //   inset 0px -4px 4px rgba(223, 227, 232, 0.7),
    //   inset 0px 4px 4px rgba(223, 227, 232, 0.7);

    ::v-deep {
      .form-input.--is-radio + .form-input.--is-radio,
      .form-input.--is-checkbox + .form-input.--is-checkbox {
        @include margin-top(map-get($spacers, 2));
      }
    }
  }

  &__content-wrapper {
    position: relative;
    flex-grow: 1;
    width: 100%;
    overflow: hidden;
    background-color: $white;

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      z-index: 1;
      width: 100%;
      @include rfs(map-get($spacers, 2), height);
      pointer-events: none;
    }

    &:before {
      top: 0;
      @include linear-gradient(180deg, rgba(0, 0, 0, 0.080), transparent);
    }

    &:after {
      bottom: 0;
      @include rfs(map-get($spacers, 4), height);
      @include linear-gradient(0, rgba(0, 0, 0, 0.080), transparent);
    }
  }

  &__content {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    @include padding(map-get($spacers, 4));
  }

  &__footer {
    display: flex;
    @include padding(map-get($spacers, 3) map-get($spacers, 4));
    background-color: $white;

    ::v-deep > .btn {
      width: 100%;
    }

    ::v-deep > .btn + .btn {
      @include margin-left(map-get($spacers, 3));
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
